// extracted by mini-css-extract-plugin
module.exports = {"bgWhite":"Header_bgWhite__1FaDa","newBtn":"Header_newBtn__3HRKr","logout":"Header_logout__1scAo","selectOption":"Header_selectOption__17Rgq"};